// ============================================
// Main App Component with Routing
// ============================================

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { DashboardPage as ClientAccountsPage } from './pages/ClientAccountsPage';
import { SubAccountDetailPage } from './pages/SubAccountDetailPage';
import { SubAccountFormPage } from './pages/SubAccountFormPage';
import { SettingsPage } from './pages/SettingsPage';
import { Layout } from './components/Layout';
import { Loader } from './components/Loader';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { admin, token, isLoading } = useAuthStore();

  if (isLoading) {
    return <Loader fullScreen />;
  }

  if (!admin || !token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="sub-accounts" element={<ClientAccountsPage />} />
        <Route path="sub-accounts/new" element={<SubAccountFormPage />} />
        <Route path="sub-account/:id" element={<SubAccountDetailPage />} />
        <Route path="sub-account/:id/edit" element={<SubAccountFormPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}